import React, { useEffect, useState } from 'react';
import { useRealtimeRides } from '../hooks/useRealtimeRides';
import { useOnlineDrivers } from '../hooks/useOnlineDrivers';
import { getAnalytics } from '../services/adminService';
import { LiveMetrics } from '../components/live/LiveMetrics';
import { DispatchMonitor } from '../components/live/DispatchMonitor';
import { ActiveRideFeed } from '../components/live/ActiveRideFeed';
import { LiveMap } from '../components/live/LiveMap';

export const LiveOperationsPage = () => {
  const { rides } = useRealtimeRides(['pending', 'accepted'], 30);
  const onlineDrivers = useOnlineDrivers();
  const [metrics, setMetrics] = useState({
    activeRides: 0,
    pendingDispatches: 0,
    failedDispatches: 0,
    todayRevenue: 0,
    systemHealth: 98,
  });

  useEffect(() => {
    setMetrics(prev => ({
      ...prev,
      activeRides: rides.filter(r => r.status === 'accepted').length,
      pendingDispatches: rides.filter(r => r.status === 'pending').length,
      onlineDrivers,
    }));
  }, [rides, onlineDrivers]);

  useEffect(() => {
    getAnalytics(1).then(data => setMetrics(prev => ({ ...prev, todayRevenue: data.totalRevenueZAR }))).catch(console.error);
  }, []);

  const handleRideCancel = (rideId) => {
    // Optional refresh
  };

  return (
    <div className="space-y-6">
      <LiveMetrics metrics={{ ...metrics, onlineDrivers }} />
      <div className="grid grid-cols-3 gap-6">
        <div className="col-span-2 h-96">
          <LiveMap />
        </div>
        <div>
          <DispatchMonitor />
        </div>
      </div>
      <ActiveRideFeed rides={rides} onCancel={handleRideCancel} />
    </div>
  );
};
